import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Para qué edades sirve?',
  a: 'De 3 a 10 años.'
}, {
  q: '¿Necesito experiencia para usarlo?',
  a: 'No. Está diseñado para cualquier mamá o docente.'
}, {
  q: '¿Es físico o digital?',
  a: 'Digital e imprimible.'
}, {
  q: '¿Cuándo recibo el acceso?',
  a: 'Inmediatamente después de la compra.'
}, {
  q: '¿Cuántas veces puedo imprimirlo?',
  a: 'Las veces que necesites para uso personal.'
}, {
  q: '¿Sirve para docentes?',
  a: 'Sí, fue diseñado tanto para el hogar como para el aula.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-slate-50" data-id="element-21">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-23">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4" data-id="element-24">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1.5 bg-pastel-blue mx-auto rounded-full" data-id="element-25"></div>
        </motion.div>

        <div className="flex flex-col gap-4" data-id="element-26">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm" data-id="element-27">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-28">
                <span className="font-bold text-slate-800 text-lg" data-id="element-29">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-30" />
              </button>
              <AnimatePresence data-id="element-31">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-32">
                    <div className="px-6 pb-5 text-slate-600 text-lg border-t border-slate-50 pt-4" data-id="element-33">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}